import axios from 'axios'
import store from '@/store'
import { CRM_API_URL } from '@/constants/api'

function fetchEmployeesStatistics (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/call-center/employees`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios
    .post(url, data, { cancelToken: source.token })
    .then((response) => response.data)
}

function exportEmployeesStatistics (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/call-center/employees/export`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios.post(url, data, {
    responseType: 'blob',
    cancelToken: source.token,
  })
}

function fetchEmployeesRevenueProportion (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/call-center/employees/revenue/proportion`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios
    .post(url, data, { cancelToken: source.token })
    .then((response) => response.data)
}

function fetchEmployeesWorkingTimeProportion (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/call-center/employees/working-time/proportion`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios
    .post(url, data, { cancelToken: source.token })
    .then((response) => response.data)
}

function fetchEmployeesUpsellingRevenueProportion (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/call-center/employees/upselling-revenue/proportion`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios
    .post(url, data, { cancelToken: source.token })
    .then((response) => response.data)
}

export default {
  fetchEmployeesStatistics,
  exportEmployeesStatistics,
  fetchEmployeesRevenueProportion,
  fetchEmployeesWorkingTimeProportion,
  fetchEmployeesUpsellingRevenueProportion,
}
